import styled from "styled-components/macro";

const BoardButton = styled.button`
  cursor: pointer;
  display: block;
  font-size: 16px;
  width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  border-radius: 24px;
  margin-left: 2px;
  border: none;
  color: #13426b;
  transition: 0.2s;
  &:hover {
    background: #278dc1;
    color: #fff;
    transform: scale(1.2);
  }
  &:active {
    background: #13426b;
    transform: scale(1);
  }
  &.focused {
    background: #13426b;
  }
`;

export default BoardButton;
